import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import flow from "lodash/fp/flow";
import constants from "../../core/constants";
import moment from "moment";
class BulkBonusesPageTransform {
  constructor() {
    "ngInject";

    this.justify = this.justify.bind(this);

    this.fields = [
      {
        title: "Operator",
        name: "userName",
      },
      {
        title: "Creation Date",
        name: "createdAt",
      },
      {
        title: "City",
        name: "cityName",
      },
      {
        title: "Pending Records",
        name: "number_of_pending_records",
      },
      {
        title: "Successful Records",
        name: "number_of_successful_records",
      },
      {
        title: "Failed Records",
        name: "number_of_failed_records",
      },
      {
        title: "Total amount processed",
        name: "total_successful_amount",
      },
      {
        title: "Currency",
        name: "cityCurrency",
      },
    ];
  }

  justify(data) {
    const getSource = (item) => assign({ _id: item._id }, item._source);
    const format = (item) => {
      item.userName = item.user.name;
      item.createdAt = moment(item.createdAt).format(constants.dateTimeFormat);
      item.cityName = item.city.name;
      item.cityCurrency = item.city.currency;
      item.total_amount /= 100;
      item.number_of_pending_records =
        item.number_of_records -
        item.number_of_successful_records -
        item.number_of_failed_records;
      return item;
    };
    return map(flow([getSource, format]))(data);
  }
}

export default BulkBonusesPageTransform;



// WEBPACK FOOTER //
// ./src/pages/bulkBonuses/bulkBonuses.transforms.js